import { jsx as e, jsxs as l, Fragment as w } from "react/jsx-runtime";
import { Popover as C, Tooltip as S, FormSelectInline as I } from "@systemeio/ui";
import { useEditorState as L } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as E, useMemo as D } from "react";
import { twMerge as T, twJoin as j } from "tailwind-merge";
import { ToolbarSelectButton as M } from "../../components/content-controls/toolbar-select-button.mjs";
import { TOOLTIP_STYLES as _ } from "../../constants/default-styles.mjs";
import { specialCharactersData as i } from "./special-characters-data.mjs";
import { SelectedCategoriesEnum as F } from "./selected-categories-enum.mjs";
import k from "../../icons/special-characters.mjs";
import { getCharactersCategoriesData as z } from "./get-characters-categories-data.mjs";
import { useTranslation as O } from "../../i18n.mjs";
const W = (c) => {
  const { t: r } = O(), [t, x] = E(F.All), [o, m] = E(null), d = L({
    editor: c,
    selector: ({ editor: n }) => ({
      isEditable: (n == null ? void 0 : n.options.editable) ?? !1
    })
  }), s = !(d != null && d.isEditable);
  return D(() => {
    var h, u, b, f, N, y, v, g;
    const n = (a) => {
      if (!c) return null;
      c.chain().focus().insertContent(a).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ e(
        C,
        {
          className: T("group"),
          popoverClassName: "bg-background-secondary rounded-lg shadow-around-sm z-40 transition duration-200 ease-out",
          disabled: s,
          anchor: "bottom",
          label: /* @__PURE__ */ l("div", { className: "max-w-[280px] lg:max-w-[320px]", children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: "border-text-secondary/30 flex items-center justify-between border-b pb-2",
                children: [
                  /* @__PURE__ */ e("span", { className: "text-text-primary text-base", children: r("special_characters.title") }),
                  /* @__PURE__ */ e(
                    I,
                    {
                      optionsClassName: "z-50",
                      onChange: (a) => a && x(a),
                      value: t,
                      data: z(r),
                      withoutCloseIcon: !0,
                      captionClassName: "no-underline"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ e("div", { className: "customScroll flex max-h-[180px] flex-wrap gap-2 overflow-auto py-3", children: i[t].map((a, p) => /* @__PURE__ */ e(
              "div",
              {
                className: "hover:border-brand-primary main-transition-colors h-[26px] w-[26px] cursor-pointer rounded-sm text-center",
                onClick: () => n(a.symbol),
                onMouseEnter: () => m(p),
                onMouseLeave: () => m(null),
                children: /* @__PURE__ */ e("span", { className: "text-text-primary text-base", children: a.symbol })
              },
              a.code
            )) }),
            /* @__PURE__ */ e("div", { className: "mt-3 flex h-5 items-center justify-between", children: o !== null && /* @__PURE__ */ l(w, { children: [
              /* @__PURE__ */ e("span", { className: "text-xs", children: r(((u = (h = i[t]) == null ? void 0 : h[o]) == null ? void 0 : u.name) ?? "") }),
              " ",
              /* @__PURE__ */ e("span", { className: "text-xs", children: (f = (b = i[t]) == null ? void 0 : b[o]) == null ? void 0 : f.code })
            ] }) })
          ] }),
          children: (a) => /* @__PURE__ */ e(
            S,
            {
              disabled: s,
              label: r("special_characters.title"),
              anchor: "left",
              ..._,
              children: /* @__PURE__ */ e(M, { disabled: s, open: a, children: /* @__PURE__ */ e(
                k,
                {
                  className: j(
                    s ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              ) })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ e(
        C,
        {
          className: T("group"),
          popoverClassName: "bg-background-secondary rounded-lg shadow-around-sm z-40 transition duration-200 ease-out",
          disabled: s,
          anchor: "bottom",
          label: /* @__PURE__ */ l("div", { className: "max-w-[280px] lg:max-w-[320px]", children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: "border-text-secondary/30 flex items-center justify-between border-b pb-2",
                children: [
                  /* @__PURE__ */ e("span", { className: "text-text-primary text-base", children: r("special_characters.title") }),
                  /* @__PURE__ */ e(
                    I,
                    {
                      optionsClassName: "z-50",
                      onChange: (a) => a && x(a),
                      value: t,
                      data: z(r),
                      withoutCloseIcon: !0,
                      captionClassName: "no-underline"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ e("div", { className: "customScroll flex max-h-[180px] flex-wrap gap-2 overflow-auto py-3", children: i[t].map((a, p) => /* @__PURE__ */ e(
              "div",
              {
                className: "hover:border-brand-primary main-transition-colors h-[26px] w-[26px] cursor-pointer rounded-sm text-center",
                onClick: () => n(a.symbol),
                onMouseEnter: () => m(p),
                onMouseLeave: () => m(null),
                children: /* @__PURE__ */ e("span", { className: "text-text-primary text-base", children: a.symbol })
              },
              a.code
            )) }),
            /* @__PURE__ */ e("div", { className: "mt-3 flex h-5 items-center justify-between", children: o !== null && /* @__PURE__ */ l(w, { children: [
              /* @__PURE__ */ e("span", { className: "text-xs", children: r(((y = (N = i[t]) == null ? void 0 : N[o]) == null ? void 0 : y.name) ?? "") }),
              " ",
              /* @__PURE__ */ e("span", { className: "text-xs", children: (g = (v = i[t]) == null ? void 0 : v[o]) == null ? void 0 : g.code })
            ] }) })
          ] }),
          children: (a) => /* @__PURE__ */ e(
            S,
            {
              disabled: s,
              label: r("special_characters.title"),
              anchor: "left",
              ..._,
              children: /* @__PURE__ */ l(M, { className: "flex gap-1", disabled: s, open: a, children: [
                /* @__PURE__ */ e(
                  k,
                  {
                    className: j(
                      s ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary",
                      "main-transition-colors"
                    )
                  }
                ),
                r("special_characters.title")
              ] })
            }
          )
        }
      )
    };
  }, [c, o, s, t, r]);
};
export {
  W as useSpecialCharactersExtensionToolbar
};
